/* Legal persons carry a tradeName, natural persons given/family name. */
export function personDisplayName(person) {
  return (
    person?.tradeName ||
    [person?.givenName, person?.familyName].filter(Boolean).join(' ')
  );
}

/* A contact is named by its caption; one without a caption by the
   name line of its postal address. Undefined where both are missing
   or RBAC nulled the whole contact: an absent name renders as an
   empty cell and sorts to the end, which an empty string would not. */
export function contactDisplayName(contact) {
  return contact?.caption || contact?.postalAddress?.name || undefined;
}
